import { Callout } from "@clipboard-health/ui-components";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { BOOKING_REQUESTS_FULL_PATH } from "../path";

interface BookingRequestsCalloutProps {
  bookingRequestsCount: number;
}

export function BookingRequestsCallout({ bookingRequestsCount }: BookingRequestsCalloutProps) {
  const history = useHistory();

  return (
    <Callout
      title={`${bookingRequestsCount} Pending ${pluralize("Request", bookingRequestsCount)}`}
      iconType="date-clock"
      sx={(theme) => ({
        color: theme.palette.shift?.bookingRequest.text,
        backgroundColor: theme.palette.shift?.bookingRequest.background,
      })}
      onClick={() => {
        history.push(BOOKING_REQUESTS_FULL_PATH);
      }}
    />
  );
}
